import Vue from 'vue'
import VueI18n from 'vue-i18n'

import fr from 'vuetify/lib/locale/fr'

Vue.use(VueI18n)

const messages = {
  en: {
    ...require('@/locales/fr.json'),
    $vuetify: fr,
  },
}

export default new VueI18n({
  silentTranslationWarn: true,
  locale: process.env.VUE_APP_I18N_LOCALE || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages,
})
